// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-9dd701a4]{border-radius:.5rem;padding:.5rem}.basket-enter-active[data-v-9dd701a4],.basket-leave-active[data-v-9dd701a4]{transition:all .3s}.basket-enter[data-v-9dd701a4]{opacity:0;transform:translatey(.5rem)}.basket-leave-to[data-v-9dd701a4]{opacity:0;transform:translateY(-.5rem)}", ""]);
// Exports
module.exports = exports;
